import { useNavigate, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import SurveyStartModal from 'modules/surveys/components/Start/SurveyStartModal'
import type Form from 'modules/surveys/store/models/Form'

const SurveyStartPage = () => {
  const { navigation } = useNavigation()

  const { form } = useOutletContext<{ form: Form }>()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.engagement.surveys.id.configuration.fullPath({ id: form.attributes.id }))
  }

  return <SurveyStartModal onClose={onClose} form={form} />
}

export default SurveyStartPage
